import FieldCheckbox from './FieldCheckbox';

export {InputCheckbox} from './FieldCheckbox';
export default FieldCheckbox;
